import { DocIndex } from 'modules/docIndex/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'
import { ARouterLink } from 'views/components/Analytics'
import BidRoutes from 'views/pages/Bid/routes'
import CompanyRoutes from 'views/pages/Company/routes'
import DealRoutes from 'views/pages/Deal/routes'
import CarriersKRRoutes from 'views/pages/LogisticsKR/CarriersKR/routes'
import DealsKRRoutes from 'views/pages/LogisticsKR/LogisticRequests/routes'
import SamplesRoutes from 'views/pages/Samples/routes'
import UserRoutes from 'views/pages/User/routes'

type Props = {
  docIndex: DocIndex
}
const getKeyVal = (docIndex: DocIndex) => {
  const data: Array<{ key: string; value: number }> = []
  docIndex.deals.forEach((deal) => {
    data.push({
      key: 'deal',
      value: deal,
    })
  })
  if (docIndex.bid) {
    data.push({
      key: 'bid',
      value: docIndex.bid,
    })
  }
  if (docIndex.company) {
    data.push({
      key: 'company',
      value: docIndex.company,
    })
  }
  if (docIndex.user) {
    data.push({
      key: 'user',
      value: docIndex.user,
    })
  }
  if (docIndex.carrier) {
    data.push({
      key: 'carrier',
      value: docIndex.carrier,
    })
  }
  if (docIndex.json_data) {
    Object.keys(docIndex.json_data).forEach((key) => {
      data.push({
        key,
        value: docIndex.json_data[key],
      })
    })
  }

  return data
}

const useGetLinks = (docIndex: DocIndex) => {
  const { t } = useTranslation('documents')
  const data = getKeyVal(docIndex)
  return data.map(({ key, value }) => {
    let text: string
    let to: string
    switch (key) {
      case 'deal':
        text = `${t('relatedObj.deal')} ID ${value}`
        to = generatePath(DealRoutes.Details, { id: value })
        break
      case 'bid':
        text = `${t('relatedObj.bid')} ID ${value}`
        to = generatePath(BidRoutes.Details, { id: value })
        break
      case 'company':
        text = `${t('relatedObj.company')} ID ${value}`
        to = generatePath(CompanyRoutes.Details, { id: value })
        break
      case 'user':
        text = `${t('relatedObj.user')} ID ${value}`
        to = generatePath(UserRoutes.Details, { id: value })
        break
      case 'carrier':
        text = `${t('relatedObj.carrier')} ID ${value}`
        to = generatePath(CarriersKRRoutes.Details, { id: value })
        break
      case 'logistics_request':
        text = `${t('relatedObj.logistics_request')} ID ${value}`
        to = generatePath(DealsKRRoutes.Details, { id: value })
        break
      case 'sample':
        text = `${t('relatedObj.sample')} ID ${value}`
        to = generatePath(SamplesRoutes.Details, { id: value })
        break

      default:
        text = `${t(`relatedObj.${key}`)} ID ${value}`
        to = ''
    }
    return { to, text }
  })
}

export const ConnectedObjectCell: FC<Props> = ({ docIndex }) => {
  const data = useGetLinks(docIndex)
  return data.map(({ to, text }, index) => {
    if (!to) return <div>{text}</div>
    return (
      <div key={index}>
        <ARouterLink eventName="docIndexLink" to={to}>
          {text}
        </ARouterLink>
      </div>
    )
  })
}
